export const isStringArray = (raw: unknown): raw is string[] =>
  Array.isArray(raw) && raw.every((r) => typeof r === 'string')
